import hrAxios from '../../../plugins/hrAxios'

const baseUrl = "Leave";

export default {
  getCategories() {
    return hrAxios.get(`${baseUrl}/categories`);
  },
  getEmployees(branchId) {
    return hrAxios.get(`${baseUrl}/employees/${branchId}`);
  },
  getLeavesByBranch(branchId) {
    return hrAxios.get(`${baseUrl}/branch/${branchId}`);
  },
  addLeave(leave) {
    return hrAxios.post(baseUrl, leave);
  }
}
